import PaginationRow from './PaginationRow';

export default PaginationRow;
